import { render, staticRenderFns } from "./horizontal.vue?vue&type=template&id=1527ae67&"
import script from "./horizontal.vue?vue&type=script&lang=js&"
export * from "./horizontal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\公司文件\\web\\uni-platform\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1527ae67')) {
      api.createRecord('1527ae67', component.options)
    } else {
      api.reload('1527ae67', component.options)
    }
    module.hot.accept("./horizontal.vue?vue&type=template&id=1527ae67&", function () {
      api.rerender('1527ae67', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/router/layouts/horizontal.vue"
export default component.exports